function useCenterInfo() {
  const centerInfo = JSON.parse(sessionStorage.getItem('centerInfo') || '{}');
  return {
    ...centerInfo,
  };
}

export default useCenterInfo;
